import * as loginActionTypes from './loginActionTypes';

const userInitialState = null;

const userReducer = (state = userInitialState, action) => {
  switch (action.type) {
    case loginActionTypes.LOG_IN:
      return {
        ...state,
        name: action.user.name
      };

    case loginActionTypes.LOG_OUT:
      return userInitialState;

    default:
      return state;
  }
}

export default userReducer;



// WEBPACK FOOTER //
// ./src/login/loginReducer.js